import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {NewsReporterDialogComponent} from '@shared/modules/shared-news/dialogs/news-reporter-dialog/news-reporter-dialog.component';
import {LinkService} from '@core/services/link.service';
import { HomeRoutes } from '@app/routes/home.routes';

@Component({
  selector: 'app-news-empty-banner',
  templateUrl: './news-empty-banner.component.html',
  styleUrls: ['./news-empty-banner.component.scss']
})
export class NewsEmptyBannerComponent implements OnInit {

  @Input() public isTeam = false;
  @Input() public isLeague = false;
  @Input() public isFromRegisterAsReporterCard = false;
  @Input() public hasReporter = false;
  public boldText = '';
  public linkToRegisterClub: string;

  constructor( public dialog: MatDialog,
               public linkService: LinkService ) { }

  public ngOnInit(): void {
    this.linkToRegisterClub = `${LinkService.getHomeLink()}/${HomeRoutes.staticPages.club}`;
    if (this.isTeam === true) {
      this.boldText = 'Leider gibt es zu diesem Team noch keine News!';
    } else if (this.isLeague === true) {
      this.boldText = 'Leider gibt es zu dieser Liga noch keine News!';
    } else if (this.hasReporter === true) {
      this.boldText = 'Du willst auch News schreiben?';
    } else if (this.isFromRegisterAsReporterCard === true) {
      this.boldText = 'Nutze fan.at als Vereinsplattform!';
    }
  }

  public onBecomeReporter(): void {
    this.dialog.open(NewsReporterDialogComponent, NewsReporterDialogComponent.getDialogSize());
  }

}
